export default {
  financial_data_from: "Finanční data z"
}